
























































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import '@/compiled-icons/calendar-month';
import '@/compiled-icons/calendar-today';
import '@/compiled-icons/calendar-week';
import '@/compiled-icons/zoom-in';
import '@/compiled-icons/zoom-out';
import '@/compiled-icons/eye';
import '@/compiled-icons/add';
import '@/compiled-icons/timer';
import '@/compiled-icons/settings';
import '@/compiled-icons/calendar-check-outline';
import AmetrasAdvancedFilterTemplate from '@/views/AmetrasAdvancedFilterTemplate.vue';
import {RANGE_SUMMARY_SERVICE_INSTANCE} from '@/services/datatable/range-summary.service';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';
import AmetrasDynamicContentDialog from '@/views/AmetrasDynamicContentDialog.vue';
import TimelineSelectInSearchDialogActionDto = DisguiseDto.TimelineSelectInSearchDialogActionDto;
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';

interface TimelineFilterDynamicContentDialogWrapper {
  dialogTitle: string;
  content: DisguiseDto.DynamicContentUnion;
  fullscreen?: boolean;
}

@Component({
  name: 'timeline-filter-panel',
  components: {
    AmetrasDynamicContentDialog,
    AmetrasFormularWrapper,
    AmetrasAdvancedFilterTemplate
  }
})
export default class TimelineFilterPanelTemplate extends Vue {

  @Prop({
    type: Object as () => DisguiseDto.TimelineFilterPanelContentDto,
    required: true
  }) panelContent!: DisguiseDto.TimelineFilterPanelContentDto;
  @Prop({
    type: Array as () => DisguiseDto.TimelineFilterPanelContentDto[],
    required: true
  }) filterConfiguration!: DisguiseDto.TimelineFilterConfigurationDto[];
  @Prop({
    type: Array as () => DisguiseDto.TimelineFilterDto[],
    required: true
  }) timelineFilters!: DisguiseDto.TimelineFilterDto[];

  @Prop({
    required: false,
    default: false
  }) submitFiltersOnUserRequest!: boolean;
  @Prop({
    required: false,
    default: false
  }) loading!: boolean;

  filterPanelValid: boolean = false; // holds the current validity status of the filter panel formular
  rangeFilterColumnIndex: number = -1; // holds the index of the current range filter settings opened
  filterPanelSimpleMode: boolean = false;
  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;
  iconService = ICONS_SERVICE_INSTANCE;

  // Dynamic Content Dialog data
  dynamicContentDialogWrapper: TimelineFilterDynamicContentDialogWrapper | null = null;
  showDynamicContentDialog: boolean = false;

  // search dialog memory variables
  activeSearchFieldFilterIndex: number = 0;
  activeSearchSelectEvent: string = '';

  /**
   * Handles the response from the advanced filter dialog.
   */
  applyAdvancedFilter(index: number, searchValues: DisguiseDto.SearchValues[]) {
    if (this.timelineFilters) {
      this.timelineFilters[index].searchValues = searchValues;
      this.timelineFilters[index].value = '';
      this.$set(this.timelineFilters, index, this.timelineFilters[index]);
      this.rangeFilterColumnIndex = -1;
      this.filterPanelSimpleMode = false;
    }
  }

  onSubmit() {
    this.$emit('submit');
  }

  getSearchValueSummary(searchValues: DisguiseDto.SearchValues[]) {
    return RANGE_SUMMARY_SERVICE_INSTANCE.getSummary(searchValues);
  }

  onComponentValueChange(filterId: string, timelineFiltersIndex: number, changeEvent: string) {
    this.timelineFilters[timelineFiltersIndex].value = changeEvent;
    for (const filterConfig of (this.filterConfiguration || [])) {
      if (filterConfig.filterId === filterId) {
        for (const event of (filterConfig.onChangeEvents || [])) {
          if (event['@type'] === 'TimelinePropagateGlobalEventAction') {
            const propagateGlobalEvent = event as DisguiseDto.TimelinePropagateGlobalEventAction;
            for (const globalEventAction of (propagateGlobalEvent.actions || [])) {
              GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(propagateGlobalEvent.eventName || '', globalEventAction);
            }
          }
        }
      }
    }
  }

  onIconClicked(iconDto: DisguiseDto.TimelineFilterIconDto, filterIndex: number) {
    if (iconDto.action) {
      if (iconDto.action['@type'] === 'TimelineDynamicContentDialogActionDto') {
        const dynamicContentDialogAction = iconDto.action as DisguiseDto.TimelineDynamicContentDialogActionDto;
        if (dynamicContentDialogAction.content) {
          this.dynamicContentDialogWrapper = {
            dialogTitle: dynamicContentDialogAction.dialogTitle || '',
            fullscreen: dynamicContentDialogAction.fullscreen || false,
            content: dynamicContentDialogAction.content
          };

          if (dynamicContentDialogAction.globalEvent) {
            this.registerGlobalEvent(dynamicContentDialogAction.globalEvent);
          }

          this.openDynamicDialog(filterIndex);
        }
      }
    }
  }

  openDynamicDialog(filterIndex?: number) {
    if (filterIndex) {
      this.activeSearchFieldFilterIndex = filterIndex;
    }

    this.showDynamicContentDialog = true;
  }

  closeDynamicDialog() {
    this.dynamicContentDialogWrapper = null;
    this.showDynamicContentDialog = false;
    this.activeSearchFieldFilterIndex = 0;
    this.detachGlobalEvent();
    this.activeSearchSelectEvent = '';
  }

  registerGlobalEvent(event: string) {
    this.activeSearchSelectEvent = event;
    GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.registerListener(
        this.activeSearchSelectEvent,
        this.globalEventListenerCallback
    );
  }

  detachGlobalEvent() {
    GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.detachListener(
        this.activeSearchSelectEvent,
        this.globalEventListenerCallback
    );
  }

  globalEventListenerCallback(eventData: any) {
    if (eventData) {
        if (eventData['@type'] === 'TimelineSelectInSearchDialogActionDto') {
          const castedSelectAction = eventData as TimelineSelectInSearchDialogActionDto;
          this.timelineFilters[this.activeSearchFieldFilterIndex].value = castedSelectAction.selectedValue;
          this.closeDynamicDialog();
        }
    }
  }
}
